import SignupModal from '@/components/_rebrand/TrialForm/Modal';
import { getStaticPageProps } from '@/lib/next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const AFFILIATIONS = ['developers', 'partners'];

const SignupPage: PageTemplate = () => {
  const router = useRouter();
  const [isAffiliated, setIsAffiliated] = useState(false);

  useEffect(() => {
    if (
      router.isReady &&
      'affiliate' in router.query &&
      AFFILIATIONS.includes((router.query.affiliate as string).toLowerCase())
    ) {
      setIsAffiliated(true);
    }
  }, [router.isReady, router.query]);

  return router.isReady ? (
    <SignupModal
      step1Heading={isAffiliated ? 'Develop on Front' : undefined}
      step1Subheading={isAffiliated ? '' : undefined}
      step2Subheading={isAffiliated ? '' : undefined}
      preventClose
    />
  ) : null;
};

SignupPage.template = ({ children }) => children;

export default SignupPage;

export const getStaticProps = getStaticPageProps('signup');
